import { WrenchCogIcon } from './WrenchCogIcon';

/**
 * author: Andrej Sharapov
 * id 321D5871-1A24-4817-9B36-AFBA993D34A0
 * name wrench-cog
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrench-cog.svg
 * tags
 * - Settings 
 * - Hardware / Tools 
 */
export const WrenchSettingsIcon = WrenchCogIcon;
export default WrenchSettingsIcon